module.exports = __webpack_public_path__ + "efc06e5289a36d46b79a3c6eb3e1633c.MP3";